import {
  CurrencyCodeEnum,
  UploadVisibilityTypeEnum,
} from "@vini-wine/core-enums";
import { PriceDto } from "@vini-wine/core-dtos";

export interface PriceModel {
  // transform
  priceMicros: number;
  currency: CurrencyCodeEnum;
  visibility: { id: UploadVisibilityTypeEnum };
}

export const createPriceDtoFromOfferPriceModel = (
  price: PriceModel,
): PriceDto => {
  return {
    priceMicros: price.priceMicros,
    currency: price.currency,
    visibility: {
      id: price.visibility.id,
    },
  };
};
